import { Controller } from "@hotwired/stimulus"
import { createTurboDataTable, destroyTurboDataTable } from "lib/datatables_turbo"
import { show_error, showBlock } from "lib/helpers"

// Human Handover tab controller for _edit_human_handover partial.
// Handles: toggle, assistant agents DataTable, add/remove agents modal.
export default class extends Controller {
  static values = {
    errorBlock: { type: String, default: "#chatbot-errors" },
  }

  connect() {
    this.assistantAgentsTable = null
    this.agentsTable = null

    this.initHumanHandoverToggleHandler()
    this.initAssistantAgentsTable()
    this.initShowListAgentsModal()
    this.initOnSelectAgentsModalclosedHandler()
  }

  disconnect() {
    if (this.assistantAgentsTable) { destroyTurboDataTable(this.assistantAgentsTable); this.assistantAgentsTable = null }
    if (this.agentsTable) { destroyTurboDataTable(this.agentsTable); this.agentsTable = null }
    $(document).off(".editHH")
    $("#check-all-assistant-agents").off(".editHH")
    $("#agents-modal").off(".agentsList")
    $(".add-agents-btn").off(".agentsList")
    $(".submit_agents_list").off(".agentsList")
  }

  initHumanHandoverToggleHandler() {
    $("#chat_assistant_notify_user_on_agent_assignment").on("change.editHH", function () {
      if ($(this).prop('checked')) $(".human-handover-control-group").removeAttr('disabled')
      else $(".human-handover-control-group").attr('disabled', 'disabled')
    })
  }

  initAssistantAgentsTable() {
    this.assistantAgentsTable = createTurboDataTable('#assistant_agents_list', {
      dom: 'rtip<"footer-toolbar">', pageLength: 10, bSort: false, pagingType: "full_numbers", serverSide: true, autoWidth: false, fixedColumns: true, order: [1, 'desc'],
      language: { emptyTable: "You haven't added any agents yet. Please add one." },
      ajax: { url: page_args.assistant_agents_path },
      footerCallback() { $('#check-all-assistant-agents').attr('checked', false) },
      fnInfoCallback(settings, start, end, max, total) {
        if ($("#reader").val() === "false" && !page_args.is_account_blocked) {
          return "Showing " + start + " of " + end + " of " + total + " entries<br><button type='button' class='remove'>Remove selected</button>"
        }
      },
      columnDefs: [
        { targets: 0, orderable: false, width: "28px", createdCell(cell, data) { $(cell).html('<input type="checkbox" class="table-checkbox-assistant-agents" id="check-assistant-agents-' + data + '" name="assistant_agents_ids[]" value="' + data + '"/> <label for="check-assistant-agents-' + data + '"></label>') } },
        { targets: 1, width: "auto", title: "Select all", createdCell(cell, data) { $(cell).html(data) } },
        { targets: [0, 1], sortable: false }
      ]
    })

    $(document).on("click.editHH", "#assistant_agents_list_info .remove", (event) => this.removeAgentsButtonHandler(event))

    $('#check-all-assistant-agents').on('change.editHH', function () {
      const isChecked = $(this).prop('checked')
      if (isChecked) { $('.table-checkbox-assistant-agents').closest('tr').addClass('selected-row').find('td').addClass('selected-row'); $('.table-checkbox-assistant-agents').prop('checked', true) }
      else { $('.table-checkbox-assistant-agents').closest('tr').removeClass('selected-row').find('td').removeClass('selected-row'); $('.table-checkbox-assistant-agents').prop('checked', false) }
    })
    $(document).on('change.editHH', '.table-checkbox-assistant-agents', function () {
      const row = $(this).closest('tr')
      if ($(this).prop('checked')) { row.addClass('selected-row'); row.find('td').addClass('selected-row') } else { row.removeClass('selected-row'); row.find('td').removeClass('selected-row') }
      const selected = $('input.table-checkbox-assistant-agents:checked').length, total = $('input.table-checkbox-assistant-agents').length
      $('#check-all-assistant-agents').prop('checked', selected > 0 && selected === total)
    })
  }

  initShowListAgentsModal() {
    const self = this, agentsErrors = '#agents-list-modal-errors'
    $("#agents-modal").off("hide.bs.modal.agentsList").on("hide.bs.modal.agentsList", () => this.removeAgentsDataTable())
    $(".add-agents-btn").off("click.agentsList").on("click.agentsList", function (e) {
      e.preventDefault()
      $("#agents-modal").modal("show")
      self.initAvailableAgentsTable()
      self.checkboxesGroupHistoryController('agents')
    })
    $(".submit_agents_list").off("click.agentsList").on("click.agentsList", function (e) {
      e.preventDefault()
      const groupName = $('input#check-all-agents').val()
      const checkboxes = $('input[name^=\'' + groupName + '\']:checked')
      const available = $('input[name^=\'' + groupName + '\']')
      if (!available.length) return false
      if (!checkboxes.length) { alert('Please select at least one item'); return false }
      const agents = $.makeArray(checkboxes.map(function () { return $(this).val() }))
      const $btn = $(this)
      $.ajax({
        url: this.href, type: "POST", dataType: "JSON", data: { agent_ids: agents },
        beforeSend() { $btn.attr('disabled', 'disabled').addClass('disabled') },
        complete() { $btn.removeAttr('disabled').removeClass('disabled'); self.finishAddAgents() },
        success(response) { if (!response.success) { const error = $(agentsErrors); if (error.length === 1) error.after(error.clone()); showBlock(agentsErrors, response.message) } },
        error() { showBlock(self.errorBlockValue, "An error occurred during request.") }
      })
    })
  }

  initAvailableAgentsTable() {
    this.agentsTable = createTurboDataTable('#agents_list', {
      dom: 'rtip<"footer-toolbar">', pageLength: 10, bSort: false, pagingType: "full_numbers", serverSide: true, autoWidth: false, fixedColumns: true, order: [1, 'desc'],
      language: { emptyTable: "You haven't added any agents yet. Please add one." },
      ajax: { url: page_args.available_agents_path },
      footerCallback() { $('#check-all-agents').attr('checked', false) },
      columnDefs: [
        { targets: 0, orderable: false, width: "28px", createdCell(cell, data) { $(cell).html('<input type="checkbox" class="table-checkbox-agents" id="check-agents-' + data + '" name="agent_ids[]" value="' + data + '"/> <label for="check-agents-' + data + '"></label>') } },
        { targets: 1, width: "auto", title: "Select all", createdCell(cell, data) { $(cell).html(data) } },
        { targets: [0, 1], sortable: false }
      ]
    })
    $('#check-all-agents').on('change.editHH', function () {
      const isChecked = $(this).prop('checked')
      if (isChecked) { $('.table-checkbox-agents').closest('tr').addClass('selected-row').find('td').addClass('selected-row'); $('.table-checkbox-agents').prop('checked', true) }
      else { $('.table-checkbox-agents').closest('tr').removeClass('selected-row').find('td').removeClass('selected-row'); $('.table-checkbox-agents').prop('checked', false) }
    })
    $(document).on('change.editHH', '.table-checkbox-agents', function () {
      const row = $(this).closest('tr')
      if ($(this).prop('checked')) { row.addClass('selected-row'); row.find('td').addClass('selected-row') } else { row.removeClass('selected-row'); row.find('td').removeClass('selected-row') }
      const selected = $('input.table-checkbox-agents:checked').length, total = $('input.table-checkbox-agents').length
      $('#check-all-agents').prop('checked', selected > 0 && selected === total)
    })
  }

  finishAddAgents() {
    this.removeAgentsDataTable()
    $("#agents-modal").modal("hide")
    if ($.fn.DataTable.isDataTable('#assistant_agents_list')) { $('#assistant_agents_list').DataTable().ajax.reload(null, false) }
    else if (this.assistantAgentsTable) { this.assistantAgentsTable.ajax.reload(null, false) }
  }

  removeAgentsDataTable() { if ($.fn.DataTable.isDataTable('#agents_list')) { this.agentsTable = destroyTurboDataTable(this.agentsTable || $('#agents_list').DataTable(), { clear: true }) } }

  removeAgentsButtonHandler(event) {
    if (event) {
      event.preventDefault()
      event.stopPropagation()
    }
    const groupName = $('input#check-all-assistant-agents').val()
    const checkboxes = $('input[name^=\'' + groupName + '\']:checked')
    if (!$('input[name^=\'' + groupName + '\']').length || !checkboxes.length) { if (checkboxes.length === 0) alert('Please select at least one item'); return false }
    const modal = $("#confirmation_remove_agent")
    modal.modal("show")
    const self = this
    modal.find("#confirm-remove-agent-button").off("click").on("click", function () { modal.modal("hide"); self.removeAgents() })
  }

  removeAgents() {
    const groupName = $('input#check-all-assistant-agents').val()
    const checkboxes = $('input[name^=\'' + groupName + '\']:checked')
    if (!checkboxes.length) return
    $('.dataTables_processing').css('display', 'block')
    const agents = $.makeArray(checkboxes.map(function () { return $(this).val() }))
    const self = this
    $.ajax({
      url: page_args.delete_agents_path, type: "DELETE", data: { agent_ids: agents },
      success() { if (self.assistantAgentsTable) self.assistantAgentsTable.draw(false) },
      error() { show_error("An error occurred during request") }
    })
    $('#check-all-assistant-agents').prop('checked', false)
  }

  initOnSelectAgentsModalclosedHandler() { $('#agents-modal').on('hidden.bs.modal.editHH', () => { $('#check-all-agents').prop('checked', false) }) }

  checkboxesGroupHistoryController(groupName) {
    const gs = 'input#check-all-' + groupName, cs = '#' + groupName + '_list tbody input[type="checkbox"]'
    $(gs).on('change', function () { $(cs).prop('checked', $(gs).is(':checked')) })
    $(cs).on('change', function () { let flag = true; $(cs).each(function () { if (!this.checked) flag = false }); $(gs).prop('checked', flag) })
  }
}
